import {Component, Input} from '@angular/core';

/**
 * A component that renders an SVG icon for "Format Align Right"
 *
 * @member {string} tooltip ? The tooltip that needs to be displayed on this icon.
 */
@Component({
    selector: 'app-icon-format-align-right',
    templateUrl: './icon-format-align-right.component.html',
    styleUrls: ['./icon-format-align-right.component.scss'],
    standalone: false
})
export class IconFormatAlignRightComponent {
  /**
   * Assign a tooltip that needs to be displayed on this icon as soon as the user hovers on it.
   *
   * @param tooltip ? The tooltip that needs to be displayed on this icon.
   */
  @Input() tooltip?: string;
}
